import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from 'app/area/case/endpoints';
import { CaseData, HttpResponse } from 'app/types-shared';

export const api = {
  
  changeCaseType: async (
    draftId: number, 
    caseTypeId: number, 
    eTag: string) => new RemoteData(endpoint.changeCaseType(draftId, caseTypeId))
      .resource<HttpResponse<CaseData>>()
      .withIfMatch(eTag)
      .save()
  
};
